import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { StyledWrapper, StyledMenuList, StyledMenuListItem, StyledBackground, StyledSocialContainer, StyledSocial, StyledLogo, StyledCopyright } from './styled'
import { Link } from 'react-router-dom'
import Facebook from './../../common/images/facebook.svg'
import Linkedin from './../../common/images/linkedin.svg'
import LogoFrNegativo from './../../common/images/logoFrNegativo.svg'
import { slugify } from './../../common'
import { HashLink } from 'react-router-hash-link';
import { useLocation } from 'react-router-dom'


const Footer = () => {

    const location = useLocation()

    // if(location.pathname === '/') return <></>

    return(
    <>
            <StyledWrapper className='d-none d-lg-flex justify-content-center'>
                <Row className='w-100'>
                    <Col 
                        xs={{
                            span: 3,
                            offset: 1
                        }}
                        className='py-5'
                    >
                        <Row>
                            <Col xs={12} >
                                <StyledMenuList>
                                    <StyledMenuListItem className='title'>
                                            <Link to='/institucional'>
                                                Institucional
                                            </Link>
                                    </StyledMenuListItem>
                                    <StyledMenuListItem>
                                        <HashLink to={`/institucional#por_que_a_fr_instalacoes`}>
                                            Por que a FR Instalações?
                                        </HashLink>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <HashLink to='/institucional#nossa_equipe'>
                                            Nossa Equipe
                                        </HashLink>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <HashLink to='/institucional#nossas_acoes'>
                                            Nossas Ações
                                        </HashLink>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <HashLink to='/institucional#segmentos_de_atuacao'>
                                            Segmentos de atuação
                                        </HashLink>
                                    </StyledMenuListItem>
                                </StyledMenuList>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} >
                                <StyledMenuList>
                                    <StyledMenuListItem className='title'>
                                        <Link to='/filosofia'>
                                            Filosofia
                                        </Link>
                                    </StyledMenuListItem>
                                    <StyledMenuListItem>
                                        <HashLink to='/filosofia#politica_da_qualidade'>
                                            Política da Qualidade
                                        </HashLink>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <HashLink to='/filosofia#visao'>
                                            Visão
                                        </HashLink>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <HashLink to='/filosofia#missao'>
                                            Missão
                                        </HashLink>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <HashLink to='/filosofia#valor'>
                                            Valor
                                        </HashLink>
                                    </StyledMenuListItem>
                                </StyledMenuList>
                            </Col>
                        </Row>
                    </Col>

                    <Col xs={3} className='py-5'>
                        <Row>
                            <Col xs={12} >
                                <StyledMenuList>
                                    <StyledMenuListItem className='title'>
                                            <Link to='/segmentos'>
                                                Segmentos
                                            </Link>
                                    </StyledMenuListItem>
                                    <StyledMenuListItem>
                                        <HashLink to='/segmentos#atuacao'>
                                            Atuação
                                        </HashLink>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <HashLink to='/segmentos#experiencia_de_mercado'>
                                            Experiência de Mercado
                                        </HashLink>
                                    </StyledMenuListItem>
                                </StyledMenuList>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} >
                                <StyledMenuList>
                                    <StyledMenuListItem className='title'>
                                        <Link to='/obras'>
                                            Obras
                                        </Link>
                                    </StyledMenuListItem>
                                    <StyledMenuListItem>
                                        <Link>
                                            Obras em execução
                                        </Link>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <Link>
                                            Obras concluídas
                                        </Link>
                                    </StyledMenuListItem>

                                    <StyledMenuListItem>
                                        <Link>
                                            Portfólio
                                        </Link>
                                    </StyledMenuListItem>
                                </StyledMenuList>
                            </Col>
                        </Row>
                    </Col>

                    <Col xs={2} className='py-5'>
                        <StyledMenuList>
                            <StyledMenuListItem className='title'>
                                <Link to='/clientes'>
                                    Clientes
                                </Link>
                            </StyledMenuListItem>
                        </StyledMenuList>

                        <StyledMenuList>
                            <StyledMenuListItem className='title'>
                                <Link to='/noticias'>
                                    Notícias
                                </Link>
                            </StyledMenuListItem>
                        </StyledMenuList>

                        <StyledMenuList>
                            <StyledMenuListItem className='title'>
                                <Link to='/contato'>
                                    Contato
                                </Link>
                            </StyledMenuListItem>
                        </StyledMenuList>

                        <StyledMenuList>
                            <StyledMenuListItem className='phone-container'>
                                <span className='ddd'>(11)</span>
                                <span className='phone'>3253-7855</span>
                            </StyledMenuListItem>
                        </StyledMenuList>
                    </Col>

                    <Col xs={2}>
                        <StyledBackground>
                            <StyledSocialContainer>
                                <StyledSocial src={Facebook}/>
                                <a target='_blank' href='https://www.linkedin.com/company/frinstalacoes'>
                                    <StyledSocial src={Linkedin}/>
                                </a>
                            </StyledSocialContainer>
                            <a target='_blank' href='https://www.facebook.com/frinstalacoes'>
                                <StyledLogo src={LogoFrNegativo}/>
                            </a>
                        </StyledBackground>
                    </Col>
                </Row>
            </StyledWrapper>
            <Row className='px-0 mx-0'>
                <Col xs={12} className='px-0 mx-0'>
                    <StyledCopyright>
                        <p>
                            © FR Instalações- All Rights Reserved.
                        </p>
                    </StyledCopyright>
                </Col>
            </Row>
        </>)
}

export default Footer